import { CryptoAsset } from '../../types/crypto';

// Using Blockscout public API (no API key required) to fetch Native and ERC20 tokens
export const fetchEvmData = async (address: string, chain: 'ethereum' | 'polygon') => {
  const baseUrl = chain === 'ethereum' ? 'https://eth.blockscout.com/api/v2' : 'https://polygon.blockscout.com/api/v2';
  
  try {
    // Fetch native balance
    const addrRes = await fetch(`${baseUrl}/addresses/${address}`);
    if (!addrRes.ok) throw new Error(`Failed to fetch ${chain} address data`);
    const addrData = await addrRes.json();
    if (addrData.coin_balance === undefined) {
      throw new Error(`Rate limit or invalid payload from ${chain} blockscout`);
    }
    
    const nativeBalanceStr = addrData.coin_balance;
    const nativeBalance = parseInt(nativeBalanceStr) / 1e18;
    const nativeUsdValue = addrData.exchange_rate ? nativeBalance * parseFloat(addrData.exchange_rate) : 0;
    const nativePriceUsd = parseFloat(addrData.exchange_rate || "0");

    // Fetch ERC-20 tokens
    const tokensRes = await fetch(`${baseUrl}/addresses/${address}/token-balances`);
    let assets: CryptoAsset[] = [];
    
    if (tokensRes.ok) {
      const tokensData = await tokensRes.json();
      const tokens = Array.isArray(tokensData) ? tokensData : (tokensData.items || []);
      
      assets = tokens
        .filter((t: any) => t.token && t.token.type === 'ERC-20' && t.value && t.value !== "0")
        .map((t: any) => {
          const decimals = parseInt(t.token.decimals || "18");
          const balance = parseFloat(t.value) / Math.pow(10, decimals);
          
          let priceUsd = 0;
          let usdValue = 0;
          if (t.token.exchange_rate) {
            priceUsd = parseFloat(t.token.exchange_rate);
            usdValue = balance * priceUsd;
          }

          return {
            id: t.token.address,
            name: t.token.name || t.token.symbol || 'Unknown Token',
            symbol: t.token.symbol || 'UNK',
            balance,
            usdValue,
            priceUsd,
            icon: t.token.icon_url,
            contractAddress: t.token.address
          };
        })
        
      if (chain === 'ethereum') {
        if (!assets.find((a: CryptoAsset) => a.symbol === 'USDC')) {
          assets.push({
            id: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
            name: 'USDC',
            symbol: 'USDC',
            balance: 0,
            usdValue: 0,
            priceUsd: 1,
            icon: 'https://assets.coingecko.com/coins/images/6319/small/USDC.png',
            contractAddress: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48'
          });
        }
      }

      assets.sort((a: CryptoAsset, b: CryptoAsset) => b.usdValue - a.usdValue);
    }

    return {
      nativeBalance,
      nativeUsdValue,
      nativePriceUsd,
      assets
    };
  } catch (error) {
    console.error(`Error fetching ${chain} data:`, error);
    throw error;
  }
};
